<template>
  <div v-if="eligible" class="private-products">
    <nav v-if="visibleProducts.length" aria-label="Your products">
      <a v-for="product in visibleProducts" :key="product.key" :href="product.url">{{ product.name }}</a>
    </nav>
    <button v-if="error" type="button" @click="load">Couldn't load your products. Retry</button>
  </div>
</template>

<script>
import axios from 'axios'
import user from '@/shared/models/user'

export default {
  data: () => ({user, products: [], loadedFor: '', error: false, request: 0}),
  computed: {
    identity() { return [this.user.id, this.user.authenticationMethod, this.user.registered].join(':') },
    eligible() { return !!this.user.id && this.user.registered && this.user.authenticationMethod !== 'guest' },
    visibleProducts() { return this.loadedFor === this.identity ? this.products : [] },
  },
  watch: {
    identity: {immediate: true, handler() { this.load() }},
  },
  mounted() {
    this.onFocus = () => this.load()
    this.onVisible = () => { if (document.visibilityState === 'visible') this.load() }
    window.addEventListener('focus', this.onFocus)
    window.addEventListener('pageshow', this.onFocus)
    document.addEventListener('visibilitychange', this.onVisible)
  },
  beforeDestroy() {
    this.request++
    this.products = []
    window.removeEventListener('focus', this.onFocus)
    window.removeEventListener('pageshow', this.onFocus)
    document.removeEventListener('visibilitychange', this.onVisible)
  },
  methods: {
    async load() {
      const request = ++this.request
      const identity = this.identity
      this.products = []
      this.error = false
      if (!this.eligible) return
      try {
        const response = await axios.get('me/products', {timeout: 10000})
        if (request !== this.request || identity !== this.identity) return
        this.products = response.data.products
        this.loadedFor = identity
      } catch (error) {
        if (request !== this.request || identity !== this.identity) return
        this.error = true
      }
    },
  },
}
</script>

<style scoped>
.private-products { margin: 20px 0; }
nav { display: flex; flex-wrap: wrap; gap: 12px 24px; }
a, button { color: #087866; font: 500 15px system-ui, sans-serif; overflow-wrap: anywhere; }
a { padding: 8px 0; }
button { text-align: left; padding: 8px 0; }
</style>
